import MensagemPadrao, { MessageType } from 'app/components/MensagemPadrao';
import React, { ReactNode, createContext, useState } from 'react';
import './styles/toast.css'
// import MensagemPadrao, { MessageType } from '../components/atoms/MensagemPadrao';

import { ToastContainer, TypeOptions, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface ToastContextProps {
    show: (type: TypeOptions, message: string, onClose?: () => void) => Promise<unknown>
}

interface ToastProvider {
    children: ReactNode
}

export const ToastifyContext = createContext<ToastContextProps>({} as ToastContextProps);

export const ToastifyProvider = (props: ToastProvider) => {

    const show = (type: TypeOptions, message: string, onClose?: () => void) => {
        return new Promise((resolve) => {
            toast(message, {
                type: type,
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                onClose: () => {
                    onClose ? onClose() : resolve(true)
                }
            })
        })
    }

    return (
        <ToastifyContext.Provider value={{ show }}>
            {props.children}
            <ToastContainer />
        </ToastifyContext.Provider>
    );
}